import { inject, Injectable } from '@angular/core';
import { VirtualFenceService } from '@vectronic/base-map';
import { dsApi, dsDtos } from '@vectronic/openApi-admin';

@Injectable({ providedIn: 'root' })
export class GetVirtualFenceService {
  private collarApi = inject(dsApi.Collars);
  private virtualFenceService = inject(VirtualFenceService);

  getVirtualFences(selectedCollarIds: number[]): void {
    const requestDto: dsDtos.CommandRequest = {
      deviceIdsFilter: selectedCollarIds,
      page: 0,
      count: 0,
      orderBy: 'insertTs',
      orderDirection: 'desc',
    };

    this.collarApi.get(requestDto).subscribe((collars: dsDtos.Collar[]) => {
      const parsedPolygons = this.virtualFenceService.dataAsPolygonStructure(collars);
      this.virtualFenceService.updateAndShowPolygons(parsedPolygons, true);
    });
  }
}
